export default __webpack_public_path__ + "static/hepburne-63f61cb21bf08aeea81f10cc4d50389b.svg";